import styled from 'styled-components';

export const GaugeContainer = styled.div`
  display: flex;
  padding-left: 8px;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  height: 45px;
  flex: 1;
`;

export const GaugeValue = styled.div`
  font-size: 16px;
  font-weight: 400;
  margin: 0 0 0 5px;
`;

export const TrendContainer = styled.div`
  overflow: hidden;
  height: 100%;
  width: 100%;
  flex: 2;
`;
